import React from 'react'
// @ts-ignore
import { ReactComponent as QuizzesNull } from './quizzes-null.svg'
import { Text } from '@trivie/ui-web/components/text'
import { color } from '@trivie/ui-web/theme'

export const LibraryQuizzesNull = (props: any) => {
  const { style } = props
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignContent: 'center',
        alignItems: 'center',
        justifyContent: 'center',
        paddingTop: 104,
        ...style,
      }}
    >
      <QuizzesNull />
      <Text
        variant="body1Medium"
        tx="Quiz.nullQuizzes"
        style={{ textAlign: 'center', color: color.shade50, marginTop: 26, width: 250 }}
      />
    </div>
  )
}
